import { render } from "./HeaderLang.vue?vue&type=template&id=095d8e4a&scoped=true"
import script from "./HeaderLang.vue?vue&type=script&lang=js"
export * from "./HeaderLang.vue?vue&type=script&lang=js"

import "./HeaderLang.vue?vue&type=style&index=0&id=095d8e4a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095d8e4a"]])

export default __exports__